module.exports = __webpack_public_path__ + "img/pen.9beff652.svg";